import { Observable } from 'rxjs';
import { FAQResponse } from '../models/faqs.model';

export abstract class FAQRepository {
    abstract getFAQs(): Observable<FAQResponse>;
}
